import {
  PokemonType,
  SkillData,
  SkillType,
  SkillRangeType,
  SkillEvent_Vfx,
  SkillEvent_MeleeHit,
} from "types/battle-engine/battle";
import { PokeNames } from "types/pokemon/poke-names";

// Splash - The famous useless move (Magikarp's specialty)
export const SPLASH: SkillData = {
  id: "splash",
  name: "Splash",
  exclusive_of: [PokeNames.MAGIKARP],
  description: "The famous useless move (Magikarp's specialty)",
  power: 0,
  pokemon_type: PokemonType.NORMAL,
  types: [SkillType.DAMAGE],
  cooldown_ticks: 30,
  mana_cost: 0,
  range: {
    type: SkillRangeType.POINT_TARGET,
    value: 1,
  },
  on_hit: [
    {
      __typename: "Vfx",
      duration_ticks: 1,
      target: {
        type: "enemy",
        id: 0,
      },
      status_effects: [],
      starting_tick: 0,
      sprite_path: "/assets/spells/impact/tiny-blue-1.png",
      sprite_scale: 0.5,
      sprite_alpha: 0.6,
      blocks_event_pipeline: false,
    } as SkillEvent_Vfx,
  ],
  on_cast: [
    {
      __typename: "MeleeHit",
      duration_ticks: 25,
      target: {
        type: "enemy",
        id: 0,
      },
      status_effects: [],
      starting_tick: 0,
      damage: 0, // No damage - it's splash!
      blocks_event_pipeline: true,
    } as SkillEvent_MeleeHit,
  ],
};